const $ = require('jquery');
const _ = require("underscore");
import LookupTable from '../../components/lookupTable/index';
import run from '../../utilities/run';
import render from "../../utilities/render";
import {teamLookupFieldDropdown} from './filter/teamLookupFields.js';
import {actionOptions} from "./filter/actionOptions.js";
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT,SUCCESS_MODAL_TIMEOUT} from "../../constants";
import {buildExport,prepareDataToSendController,isEdit,readSpecificObjectFromCurrentData,doAjax,readSpecificKeyFromSearchCriteria,alterSearchCriteriForController,pushFilterSessionCacheState,retriveCriteriaObjectByOperation,isNew,isDeleteView,isOnlyLookupDataUpdate} from "../../utilities/filtersutil";
import { handleCustomDropdownEvents } from "../../utilities/customBootstrapDropdowns";
let actionList = actionOptions;
const targetSelector = "#user-lookup";

let actionCellDropdownTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionCellDropdown.html');
let actionCellDropdownItemTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionCellDropdownItem.html');
let actionHeaderDropdownTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionHeaderDropdown.html');

run(targetSelector, ()=>{
	  const dataTableComponentData = $(targetSelector).data("user-lookup-data");
    const getUserDetailRowDataUrl  =  $(targetSelector).data("user-detail-url");
    const getEditUserURL  =  $(targetSelector).data("user-edit-url");
    const generateExportUrl  =  $(targetSelector).data("export-url");
    const savedViews  =  $(targetSelector).data("saved-views");
    const portletNamespace =  $(targetSelector).data("portlet-namespace");
    const shouldCheckCache  =  $(targetSelector).data("should-check-cache");
    const criteriaObjectFromServer  =  $(targetSelector).data("filter-criteria-from-server");
    const filterTeamUrl =  $(targetSelector).data("user-filter-url");
    const saveViewURL  =  $(targetSelector).data("save-view-url");
    const deleteViewURL  =  $(targetSelector).data("delete-view-url");

    //POD logic, added to check in the current retailer is POD retailer
    const hasSubOrganizations = $(targetSelector).data("has-sub-organizations");
    let variableColumnData = "jobTitle";
    let variableColumnLabel = "Title";

    let exportModal = new buildExport(); 
    let targetObject = "";
    if(shouldCheckCache)
    {
        targetObject = retriveCriteriaObjectByOperation(criteriaObjectFromServer,"like");
    }
    if(hasSubOrganizations)
    {
      variableColumnData = "assignedSubOrg";
      variableColumnLabel = "Business Unit";
    }
    else
    {
      variableColumnData = "jobTitle";
      variableColumnLabel = "Title";
    }

    let userLookup = new LookupTable({
    // REQUIRED - Set a target element
    target: $("#lookup-user-wrapper"),
    // Set a target class for min width, needs to be a "til-x" class so it doesn't interfere with mobile widths
    minWidthClass: "q-min-width-sm-til-md",
    // REQUIRED - Set which data should be visible for mobile
    mobileColumns: [
      {
        data: "fullName", 
        title: "Name",
        render: renderUserDetailLink
      },
      {
        data: "status",
        title: "Status",
        render: renderStatusPill
      },
      {
        data: "emailAddress", 
        title: "Email"
      },
      {
        data: "phone", 
        title: "Phone"
      },
      {
        data: "selectedChildRetailersNames", 
        title: "Merchant"
      },
      {
        data: "selectedRoleNames", 
        title: "Role"
      },
      {
          data: variableColumnData, 
          title: variableColumnLabel
      }      
    ],
    paginationData:dataTableComponentData.page,
    filterModal: {
      // REQUIRED: Sets title of modal
      title: "Filter Users",
      // REQUIRED: Sets unique part of subtitle string.
      tableType: "team"
    },
    tableSearchInput: {
      // Not required
      // placeholder: 'Custom Search Text'
      value: (targetObject != "" ? targetObject.value[0] : "")

    },
    // REQUIRED - THIS IS TEMPORARY, WILL BE DEPRECATED WHEN WE ENABLE SEARCH INPUT ONLY
    tableSearchDropdown: {
      selected: (targetObject == "" ? "" : targetObject.key),		
      columns:teamLookupFieldDropdown
    },
    savedViews: savedViews,
    bulkSelect: false,
    // REQUIRED - Data Table specific settings 
    dataTable: {
    // use same settings you would if you were just calling a dataTable normally
    data: dataTableComponentData.content,

  
    columns: [
        {
        data: "userId",
        title: "Actions",
        render : renderActionWrap,
        orderable:false, 
        class: 'dtc-action-column'
        },
        {
          data: "fullName", 
          title: "Name",
          render: renderUserDetailLink
        },
        {
          data: "status",
          title: "Status",
          render: renderStatusPill
        },
        {
          data: "emailAddress", 
          title: "Email"
        },
        {
          data: "phone", 
          title: "Phone",
          orderable:false
        },
        {
          data: "selectedChildRetailersNames", 
          title: "Merchant"
        },
        {
          data: "selectedRoleNames", 
          title: "Role",
          orderable:false
        },
        {
          data: variableColumnData, 
          title: variableColumnLabel
        }
      ]
    },
    onFetch: function() {
      let currentData = userLookup.generateData();
      userLookup.showLoadingOverlay();
      if(isOnlyLookupDataUpdate(currentData)) {
          setTimeout(() => {
          doAjax({url: filterTeamUrl, success: filterSuccessFun, error: errorFun,data:prepareDataToSendController(currentData)});
        },SUCCESS_MODAL_TIMEOUT);
      } else if(isNew(currentData)) {
          setTimeout(() => {
          doAjax({url: saveViewURL, success: savedViewSuccess, error: errorFun, data:prepareDataToSendController(currentData)});
        },SUCCESS_MODAL_TIMEOUT);
      } else if(isEdit(currentData)) {
          setTimeout(() => {
          doAjax({url: saveViewURL, success: savedEditViewSuccess, error: errorFun, data:prepareDataToSendController(currentData)});
        },SUCCESS_MODAL_TIMEOUT);
      } else if(isDeleteView(currentData)) {	   	
          setTimeout(() => {
          doAjax({url: deleteViewURL, success: delteViewScussFun, error: errorFun, data:prepareDataToSendController(currentData)});
        },SUCCESS_MODAL_TIMEOUT);
      }
    }
  });

  userLookup.init();

  //Methods used for the Actions/Bulk Actions 
  function renderActionWrap(data, type, row, meta) {
    let newRender;
    let statusTarget = actionList["actions"];
    newRender = render(
      actionCellDropdownTemplate, {
        list: renderActionCellList(statusTarget,data,row),
        index: meta.row
      }
    );
    return newRender;
  }

  function renderActionCellList(list,data,row) {
    let renderedList;
    renderedList = _(list).map((item)=>{
      return render(
        actionCellDropdownItemTemplate, {
          icon: item.icon,
          title: item.title,
          cls: item.cls,
          disabled:false
        }
      );
      });
    return renderedList.join('');
  }

  //Methods used for the Filter and Success
  function filterSuccessFun(data) {  
    let users = data.content;
    let page = data.page;
    userLookup.setNewData(users);
    userLookup.setPaginationData(page)
    pushFilterSessionCacheState();
    userLookup.hideLoadingOverlay();
    setExportData(userLookup.generateData());
	}

	function savedViewSuccess(data) { 
    let jsonData = JSON.parse(data.commerceUsersJson);
    let users = jsonData.content;
    let page = jsonData.page;
	  userLookup.setNewData(users);
	  userLookup.setPaginationData(page);
	  userLookup.setNewSavedViewData(data.savedView, "newSavedView");
	  pushFilterSessionCacheState();
	  userLookup.hideLoadingOverlay();
    setExportData(userLookup.generateData());
	}


	function savedEditViewSuccess(data) { 
    let jsonData = JSON.parse(data.commerceUsersJson);
    let users = jsonData.content;
    let page = jsonData.page;
	  userLookup.setNewData(users);
	  userLookup.setPaginationData(page);
	  userLookup.setNewSavedViewData(data.savedView, data.savedView.target);
	  pushFilterSessionCacheState();
	  userLookup.hideLoadingOverlay();
    setExportData(userLookup.generateData());
	}


	function delteViewScussFun(data) { 
    let jsonData = JSON.parse(data.commerceUsersJson);
    let users = jsonData.content;
    let page = jsonData.page;
    userLookup.removeSavedView(data.target);
    userLookup.setNewData(users);
    userLookup.setPaginationData(page);
    userLookup.hideLoadingOverlay();
    setExportData(userLookup.generateData());
	}

	function errorFun(data) {
    userLookup.hideLoadingOverlay();
	}

  //Method to pouplate the User name as link 
  function renderUserDetailLink(data, type, row) {
    let linkHTML = "<a href={%=userDetailURL%}&userId={%-row.userId%}> {%-data%} </a>";
    let userInfoLink = render ( 
      linkHTML, {
        userDetailURL: getUserDetailRowDataUrl,
        data: data,
        row: row
      }
    );
    return userInfoLink;
  }

  //Method to pouplate the Status with a Pill Fill
  function renderStatusPill(data, type, row) {
    let renderStatus;
    let statusHTML;
    if(data == "Active") {
      statusHTML = "<div class='q-pill q-pill-blue q-pill-detail'>{%-data%}</div>";
    } else {
      statusHTML = "<div class='q-pill q-pill-blue-border q-pill-detail'>{%-data%}</div>";
    }
    renderStatus = render(
      statusHTML, {
        data: data
      }
    );
    return renderStatus;
  }

  //On click of Edit from the table view directly 
  $('body').on( 'click', '.edit-team', function (e) {
    e.preventDefault();
    let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
    // Get the row based on the parent...
    let parent = $(".dropdown-parent-" + pIndex).parents('tr');
    // Get the row data
    let row = $(".data-table-component").dataTable().api().row(parent);
    let user = row.data();
	  location.href = `${getEditUserURL}&${portletNamespace}userId=${user.userId}`;  
	 
  });

  

  //Methods driven for Export functionality 
 //  $("#exportData").click(function() {
 //      let totRowCount = $('#totalRows').val();
 //      $('#modalExportData').attr('disabled', true);
 //      $('#dataFileType').val('0');
 //      $('#row-count').html(" " + totRowCount + " ");
 //      $("#exportModal").appendTo("body").modal("show");
	// });


	// $('#modalExportData').click(function() {
 //      let fileType = $('#dataFileType :selected').val();
 //      exportToFile(fileType);
 //      $("#exportModal").modal("hide");
	// });
			
			
	// $('#dataFileType').change(function() {
	// 	  $('#modalExportData').attr('disabled', false);
	// });
	
	// let exportToFile = function(fileType) {
 //    let currentData = userLookup.generateData();
 //  	const startDate = readSpecificKeyFromSearchCriteria(currentData["searchCriteria"],'startDate');
	// 	const endDate = readSpecificKeyFromSearchCriteria(currentData["searchCriteria"],'endDate');	
	// 	const fixedRangeDate = readSpecificKeyFromSearchCriteria(currentData["searchCriteria"],'fixedRange');	
	// 	const revisedSearchCriteria =  alterSearchCriteriForController(currentData["searchCriteria"]);
 //    const orderBy = "emailAddress";
	// 	const searchCriteria =   _.toArray(revisedSearchCriteria).length > 0 ? JSON.stringify(_.toArray(revisedSearchCriteria)) : _.toArray(revisedSearchCriteria);
	// 	const url = generateExportUrl+"&endDate="+endDate+"&startDate="+startDate+"&fixedRange="+fixedRangeDate+"&page=0"+"&size=1000"+"&orderBy="+orderBy+"&orderByType="+currentData["sortType"]+"&searchCriteria="+searchCriteria+"&fileType="+fileType;
	// 	window.open(url);
	// }; 


  // Export component integration.
  function initExport() {
    let exportObj  =  {
      title : $(targetSelector).data("export-popup-title"), 
      exportAttemptTextPart1Lang: $(targetSelector).data("export-attempt-text-part1"), 
      exportAttemptTextPart2Lang: $(targetSelector).data("export-attempt-text-part2"),
      exportMaxLimitLang: $(targetSelector).data("export-max-row-limit")
    }; 
    exportModal.init(exportObj);
    exportModal.bindExportEvent();
  }

  function setExportData(currentData) {
    exportModal.buildExportBasicURL(generateExportUrl,currentData);
    exportModal.setExportCount(currentData.totalElements);
  }

  initExport();
  setExportData(userLookup.generateData());
  handleCustomDropdownEvents();


});


// WEBPACK FOOTER //
// ./src/pages/teamMembers/userLookup.js